import { createSelector } from "reselect";

export const getUserConversations = (state) => state.user_conversations;

export const makeGetUserConversationSelector = (conversationId) => {
  return createSelector(getUserConversations, (userConversations) => {
    const result = userConversations.get(`${conversationId}`);
    return result ? result.toJS() : undefined;
  });
};

export const getAllMutedConversationIds = createSelector(getUserConversations, (userConversations) =>
  userConversations
    .filter((uc) => uc.get("is_muted", false))
    .keySeq()
    .toArray()
    .map((value) => Number(value))
);
